
  <div class="container-fluid text-center">
    <p>{{ currentYear }} &copy; <strong>CEDLab</strong> powered by CSolution srl - Lungotevere dei Mellini 10 - 00193 - Roma (RM) - IT - P.I. 13364991003</p>
  </div>

